import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import AvatarMenu from '../components/AvatarMenu';
import BackButton from '../components/BackButton';
import TournamentCard from '../components/TournamentCard';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const FORMAT_CHIPS = ['Tous', '2×2', '3×3', '4×4', 'Mixte'];

function GroupActivity({ user, onLogout }) {
  const [entries, setEntries]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [query, setQuery]       = useState('');
  const [format, setFormat]     = useState('Tous');
  const token = localStorage.getItem('token');

  const fetchEntries = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/users/me/group-activity`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEntries(res.data || []);
    } catch {
      setEntries([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchEntries(); }, [fetchEntries]);

  const filtered = entries.filter(item => {
    const t = item.tournament;
    const matchQuery = !query || t.name.toLowerCase().includes(query.toLowerCase());
    const matchFormat = format === 'Tous' || (t.playerFormat || '').toLowerCase().includes(format.replace('×', 'x').toLowerCase());
    return matchQuery && matchFormat;
  });

  return (
    <>
      <div className="app-header">
        <div className="header-inner">
          <div className="header-row">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <BackButton />
              <div>
                <div className="header-title">Tournois de vos amis</div>
                <div className="header-subtitle">
                  {!loading && `${filtered.length} tournoi${filtered.length !== 1 ? 's' : ''}`}
                </div>
              </div>
            </div>
            <AvatarMenu user={user} onLogout={onLogout} />
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="search-bar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--sub)', flexShrink: 0 }}>
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
          </svg>
          <input
            type="text"
            placeholder="Rechercher un tournoi…"
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          {query && (
            <button onClick={() => setQuery('')}
              style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'var(--sub)', fontSize: 18, lineHeight: 1, padding: 0 }}>
              ×
            </button>
          )}
        </div>

        <div className="chips-row" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 8 }}>
          {FORMAT_CHIPS.map(f => (
            <button key={f} onClick={() => setFormat(f)}
              className={`chip${format === f ? ' active' : ''}`}>
              {f}
            </button>
          ))}
        </div>

        {loading && (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--sub)', fontSize: 13 }}>
            Chargement…
          </div>
        )}

        {!loading && filtered.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🏐</div>
            <p className="empty-text">
              {query || format !== 'Tous'
                ? 'Aucun résultat pour ces filtres'
                : 'Vos amis ne jouent aucun tournoi à venir'}
            </p>
            {!query && format === 'Tous' && (
              <p style={{ fontSize: 13, color: '#B0C0D0', margin: '8px 0 20px' }}>
                Rejoignez des groupes pour voir les tournois de vos amis.
              </p>
            )}
          </div>
        )}

        {!loading && filtered.map((item, i) => (
          <TournamentCard key={i}
            tournament={item.tournament}
            group={item.group}
            friends={item.friends}
          />
        ))}
      </div>
    </>
  );
}

export default GroupActivity;
